import { LocaleService } from "../../services/locale-service";
import { SelectItem } from "../../components/select-item";

export enum DownloadType {
  PDF,
  STEP,
}

export class FileNameResult {
  filename: string;
  error: string;
}

export class Pumpentyp extends SelectItem {}
export class Drehrichtung extends SelectItem {}
export class Befestigungsart extends SelectItem {}
export class Fluessigkeitsvorlage extends SelectItem {}
export class Gehaeuseanschluss extends SelectItem {}
export class Ventilanbau extends SelectItem {}
export class Gehaeusewerkstoff extends SelectItem {}

export class MatrixData {
  drehrichtungen: Drehrichtung[];
  befestigungsarten: Befestigungsart[];
  fluessigkeitsvorlagen: Fluessigkeitsvorlage[];
  gehaeuseanschluesse: Gehaeuseanschluss[];
  ventilanbauten: Ventilanbau[];
  gehaeusewerkstoffe: Gehaeusewerkstoff[];
}

export class ProductfinderDownloadData {
  constructor(other?: ProductfinderDownloadData) {
    if (other) $.extend(true, this, other);
  }

  pumpentyp: Pumpentyp;
  drehrichtung: Drehrichtung;
  befestigungsart: Befestigungsart;
  fluessigkeitsvorlage: Fluessigkeitsvorlage;
  gehaeuseanschluss: Gehaeuseanschluss;
  ventilanbau: Ventilanbau;
  gehaeusewerkstoff: Gehaeusewerkstoff;

  /**
   * Returns a clone of this instance, which can be used to send it to the
   * server. In the cloned instance, all number fields which contain
   * strings at runtime (due to databinding of the input fields) are
   * replaced with float values.
   *
   * @param localeService needed to convert strings to floats, using current
   * locale
   */
  createCopyForServer(localeService: LocaleService): ProductfinderDownloadData {
    // clone this, see http://stackoverflow.com/a/122704/1601438
    let clone = $.extend(true, {}, this);
    delete clone["__metadata__"];
    delete (clone as any)["createCopyForServer"];
    return clone;
  }

  clear() {
    (<any>this).pumpentyp = undefined;
    (<any>this).drehrichtung = undefined;
    (<any>this).befestigungsart = undefined;
    (<any>this).fluessigkeitsvorlage = undefined;
    (<any>this).gehaeuseanschluss = undefined;
    (<any>this).ventilanbau = undefined;
    (<any>this).gehaeusewerkstoff = undefined;
    (<any>this).downloadType = undefined;
  }
}
